import { baseUrl } from 'volto-ebc-radionacional/utils/api';
import { normalizeImageUrl } from 'volto-ebc-radionacional/utils/normalizeImageUrl';

import type { ProgramItem } from 'volto-ebc-radionacional/components/shared/ProgramCarouselSection/ProgramCarouselSection.types';

type GetProgramsParams = {
  page?: number;
  search?: string;
  archive?: boolean;
};

export function normalizePrograms(data: unknown): ProgramItem[] {
  const items = Array.isArray(data) ? data : [];

  return items.map((item: any) => ({
    '@id': item?.['@id'] ?? '',
    title: item?.title ?? '',
    description: item?.description ?? '',
    image: normalizeImageUrl(item?.image),
    archive: item?.archive === true,
    type_title: 'Programa',
    review_state: 'published',
    '@type': 'Programa',
  }));
}

export async function getPrograms({
  page = 0,
  search = '',
  archive,
}: GetProgramsParams = {}): Promise<ProgramItem[]> {
  try {
    const safePage = Math.max(0, page);
    const params = new URLSearchParams();

    if (safePage > 0) {
      params.set('page', String(safePage));
    }

    if (search.trim()) {
      params.set('SearchableText', search.trim());
    }

    if (archive !== undefined) {
      params.set('archive', String(archive));
    }

    const query = params.toString();
    const url = query
      ? `${baseUrl}/@programs?${query}`
      : `${baseUrl}/@programs`;

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(
        `Erro ao buscar programas: ${response.status} ${response.statusText}`,
      );
    }

    if (response.status === 204) {
      return [];
    }

    const data = await response.json();
    return normalizePrograms(data);
  } catch (error) {
    console.error('Falha ao buscar programas:', error);
    return [];
  }
}
